module.exports = __webpack_public_path__ + "img/zss_xy_q2.9b0d0ded.png";